import { Route, Routes } from "react-router-dom";
import ProductsPage from "../../pages/shared-pages/products/ProductsPage";
import NewProductPage from "../../pages/shared-pages/products/NewProductPage";
import UpdateProductPage from "../../pages/shared-pages/products/UpdateProductPage";
import ProductDetailsPage from "../../pages/shared-pages/products/ProductDetailsPage";

export default function ProductNav() {
  return (
    <Routes>

      <Route path="/" element={<ProductsPage />} />
      <Route path="/new" element={<NewProductPage />} />
      <Route path="/update" element={<UpdateProductPage />} />
      <Route path="/details" element={<ProductDetailsPage />} />

    </Routes>
  )
}
